import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const post = (scopeStringId, mappingConfig) =>
  requestsTemplates.post(mainPath, `/mapping_fields`, {
    ...mappingConfig,
    scope: scopeStringId,
  });
